export class MetaDataModel {
    monoPageCountPerMonth: number;
    colorPageCountPerMonth: number;
}
